import {Storage} from "@/Services/Storage";
import axios from "axios";

export default {
    name: 'user',
    state: {
        allUsers : [],
        warehouseManagers : {},
        currentUser : {},
        supervisors: [],
    },
    getters: {
        getAllUsers: (state) => Storage.getAllUsers(),
        getCurrentUser : (state) => Storage.getCurrentUser(),
        getWarehouseManagers: (state) => Storage.getWarehouseManagers(),
        getSupervisors: (state) => Storage.getSupervisors()
    },
    mutations: {
        setAllUsers: async (state, payload) => {
            if (payload) await Storage.setAllUsers(payload)
            else payload = await Storage.getAllUsers();
            state.allUsers = payload ? payload : [];
        },

        setWarehouseManagers: async (state, payload) => {
            if (payload) await Storage.setWarehouseManagers(payload)
            else payload = await Storage.getWarehouseManagers();
            state.warehouseManagers = payload ? payload : [];
        },

        setSupervisors: async (state, payload) => {
            if (payload) await Storage.setSupervisors(payload)
            else payload = await Storage.getSupervisors();
            state.supervisors = payload ? payload : {};
        },

        setCurrentUser: async (state, payload) => {
            if (payload) await Storage.setCurrentUser(payload)
            else payload = await Storage.getCurrentUser();
            state.currentUser = payload ? payload : {};
        },
    },
    actions: {
        /**
         * Fetch all users from WarehouseManager NAV route
         * GET: nav/users/all
         * Uses global navTomcatApi (wareHouseTomcatApi + 'nav/')
         * @returns {Promise<void>}
         */
        getAllUsers: async (context) => {
            return axios.get(navTomcatApi + `users/all`)
                .then(({data}) => context.commit('setAllUsers', data))
                .catch(err => errorHandler.tomcatError(err))
        },
        /**
         * Fetch all supervisors
         * GET: wareHouseTomcatApi + 'nav/supervisor'
         * Filters are handled at the point of use (e.g., component filters by process_type === 'checkout').
         * @returns {Promise<void>}
         */
        getSupervisors: async (context) => {
            return axios.get(wareHouseTomcatApi + `nav/supervisor`)
                .then(({ data }) => context.commit('setSupervisors', data))
                .catch(err => errorHandler.tomcatError(err))
        },
        getWarehouseManagers: async (context) => {
            return axios.get(wareHouseTomcatApi+`nav/picking/getAllWarehouseManagers`)
                .then(({data})=>context.commit('setWarehouseManagers',data))
                .catch(err=>errorHandler.tomcatError(err))
        },
        validateLogin : async (context,payload) =>{
            try {
                const res = await axios.post(wareHouseTomcatApi + `auth/login`, {
                    username: payload.username,
                    password: payload.password,
                })

                const currentUser = res.data;
                if (currentUser) {
                    await context.commit(`setCurrentUser`, currentUser)
                    return true;
                }
                return false;
            } catch (e){
                errorHandler.tomcatError(e)
                return false;
            }
        },
        validateManager: async (context, otp) => {
            try {
                const res = await axios.post(`${wareHouseTomcatApi}nav/otp/verify-checkout?otp=${otp}`);
                return res.status === 200;
            } catch (err) {
                console.error("OTP verification error:", err);
                return false;
            }
        }
    }
}
